import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Application, EntryPoint } from '@wellesley/openapi'
import { rootReducer } from '@wellesley/store'

export type AppsListState = {
  entryPoint: EntryPoint
  isOpen: boolean
  list: Application[] | null
  activeGroupName?: string | null
}

const initialState: AppsListState = {
  entryPoint: 'GLOBAL',
  isOpen: false,
  activeGroupName: null,
  list: null,
}

export const appsListSlice = createSlice({
  name: 'appsList',
  initialState,
  reducers: {
    setList: (
      state,
      action: PayloadAction<{
        list: Application[]
        entryPoint: EntryPoint
        activeGroupName?: string | null
      }>,
    ) => {
      state.list = action.payload.list
      state.entryPoint = action.payload.entryPoint
      state.activeGroupName = action.payload.activeGroupName
    },
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload
    },
  },
  selectors: {
    selectList: (state) => state.list,
    selectEntryPoint: (state) => state.entryPoint,
    selectActiveGroupName: (state) => state.activeGroupName,
    selectIsOpen: (state) => state.isOpen,
  },
}).injectInto(rootReducer)
